export default {
  constantQassatlyRepaymentStatus: {

    value: {
      Ready_To_Pay: 'ready_to_pay',
      Upcoming: 'upcoming',
      Paid: 'paid',
      Paid_Late: 'paid_late',
      Deleted: 'deleted',
    },
    name: {
      Ready_To_Pay: 'Ready To Pay',
      Upcoming: 'Upcoming',
      Paid: 'Paid',
      Paid_Late: 'Paid Late',
      Deleted: 'Deleted',

    }
  }
}
